import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { find, forEach, get } from 'lodash';
import summaryTitle from 'lib/seats/summaryTitle';
import pricesForZone from 'lib/pricing/pricesForZone';
import { toCurrency } from 'lib/common/displayHelpers';

import { IconRemove } from 'components/Icons';
import Price from 'components/Price';

class LineItem extends Component {
  constructor(props) {
    super(props);

    this.handlePriceTypeChange = this.handlePriceTypeChange.bind(this);
    this.enforcePackageLimits = this.enforcePackageLimits.bind(this);
  }

  handlePriceTypeChange(event) {
    const { prices, additionalPrices, lineItem, onChangeUpdatePrice } = this.props;

    const allPrices = [].concat(
      pricesForZone(prices, lineItem.seatData.zone_no),
      pricesForZone(additionalPrices, lineItem.seatData.zone_no)
    );

    const priceData = find(allPrices, function(item) {
      return parseInt(item.price_type, 10) === parseInt(event.target.value, 10);
    });

    onChangeUpdatePrice(lineItem, priceData);
  }

  enforcePackageLimits(allPrices) {
    const { priceTypeOptions, lineItems } = this.props;

    // Mark it as enabled here becase we return stuff early
    // to avoid nasty nested if statements
    allPrices = allPrices.map(price => {
      price.disabled = false;

      return price;
    });

    const primaryPriceTypes = get(priceTypeOptions, 'primaryPriceTypes', null);
    const addOnPriceTypes = get(priceTypeOptions, 'addOnPriceTypes', null);

    const fulfilledPriceTypes = [];

    if (primaryPriceTypes) {
      forEach(primaryPriceTypes, (priceTypeLimits, priceType) => {
        const priceTypeLineItems = lineItems.filter(lineItem => {
          return parseInt(priceType, 10) === parseInt(lineItem.priceData.price_type, 10);
        });

        if (priceTypeLineItems.length === parseInt(priceTypeLimits.maxSeats, 10)) {
          fulfilledPriceTypes.push(parseInt(priceType, 10));
        }
      });
    }

    if (addOnPriceTypes) {
      forEach(addOnPriceTypes, (priceTypeLimits, priceType) => {
        const priceTypeLineItems = lineItems.filter(lineItem => {
          return parseInt(priceType, 10) === parseInt(lineItem.priceData.price_type, 10);
        });

        if (priceTypeLineItems.length === parseInt(priceTypeLimits.maxSeats, 10)) {
          fulfilledPriceTypes.push(parseInt(priceType, 10));
        }
      });
    }

    return allPrices.map(price => {
      // We need to make them disabled
      price.disabled = fulfilledPriceTypes.indexOf(parseInt(price.price_type, 10)) !== -1;

      // Return price object
      return price;
    });
  }

  render() {
    const {
      lineItem,
      prices,
      additionalPrices,
      onChangeUpdatePrice,
      onClickRemoval,
      onClickReselect,
    } = this.props;

    let allPrices = [].concat(
      pricesForZone(prices, lineItem.seatData.zone_no),
      pricesForZone(additionalPrices, lineItem.seatData.zone_no)
    );

    allPrices = this.enforcePackageLimits(allPrices);

    const showMultiplePriceTypes = onChangeUpdatePrice && allPrices.length > 1;

    return (
      <div
        className={classnames({
          'syos-lineitem': true,
          'syos-lineitem--multiple': showMultiplePriceTypes
        })}
      >
        <span className="syos-lineitem__details">
          {!lineItem.isLocked && (
            <button
              className="syos-lineitem__remove"
              type="button"
              onClick={onClickRemoval}
              aria-label="Remove this seat"
            >
              <IconRemove />
            </button>
          )}
          {lineItem.isLocked ? (
            <span className="syos-lineitem__title">
              {summaryTitle(lineItem.seatData)}
            </span>
          ) : (
            <button
              className="syos-lineitem__title u-syos-button-reset"
              onClick={onClickReselect}
              type="button"
            >
              {summaryTitle(lineItem.seatData)}
            </button>
          )}
        </span>
        <span className="syos-lineitem__price">
          {showMultiplePriceTypes ? (
            <span className="syos-price-switch">
              <select
                className="syos-price-switch__select"
                onChange={this.handlePriceTypeChange}
                value={lineItem.priceData.price_type}
              >
                <optgroup label="Change your price">
                  {allPrices.map(function(price, index) {
                    return (
                      <option key={index} value={price.price_type} disabled={price.disabled}>
                        {`${price.price_type_alias_desc || price.price_type_desc} ${toCurrency(price.price)}`}
                      </option>
                    );
                  })}
                </optgroup>
              </select>
            </span>
          ) : (
            <Price
              priceData={lineItem.priceData}
              showDescription={prices.length > 1}
            />
          )}
        </span>
      </div>
    );
  }
}

LineItem.propTypes = {
  mode: PropTypes.string,
  lineItems: PropTypes.array,
  lineItem: PropTypes.object,
  prices: PropTypes.array,
  additionalPrices: PropTypes.array,
  priceTypes: PropTypes.arrayOf(PropTypes.object).isRequired,
  additionalPriceTypes: PropTypes.arrayOf(PropTypes.object),
  onClickRemoval: PropTypes.func,
  onClickReselect: PropTypes.func,
  onChangeUpdatePrice: PropTypes.func,
  priceTypeOptions: PropTypes.object,
};

export default LineItem;



// WEBPACK FOOTER //
// ./src/javascripts/components/LineItem.js